export default __webpack_public_path__ + "static/media/Sellers tab_closing.399ff599.jpg";